<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16suoLh/tc-custom/9780802157409.jpg?1736424015302" alt="This image is the cover for the book Magma"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Magma
      </h1>
      <p class="bookDescription body article font2">
        <b>“The provocative Icelandic poet’s debut novel . . . urgently explores the challenges and costs of a young woman’s passionate yet toxic relationship.” —<i>Time</i>, Best Books of Summer 2021</b><br/><br/>As a young university student, Lilja is quickly smitten with the intelligent, beautiful young man from school who quotes Derrida and reads Latin and cooks balanced vegetarian meals. Before she knows it, she’s moved into his cramped apartment, surrounded by sour towels and flat Diet Cokes. As the newfound intimacy of sharing a shower and a bed fuels her desire to please her partner, his subtle abuses continue to mount undetected. Lilja desperately tries to meet his every need, slowly losing her sense of self in the process.<br/><br/>In her debut novel, Thora Hjörleifsdóttir sheds light on the commonplace undercurrents of violence that so often go undetected in romantic relationships. She deftly illustrates the failings of psychiatric systems in recognizing symptoms of cruelty, and in powerful, poetic prose depicts the unspooling of a tender-hearted woman desperate to love well.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thora Hjörleifsdóttir
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Atlantic
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3a4c2e12